import { NativeStackHeaderProps, Stack, useRouter } from 'expo-router';
import useAccountStatements from 'features/myVaro/hooks/statementsAndForms/useAccountStatements';
import { MyVaroContext } from 'features/myVaro/provider/MyVaroContextProvider';
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { FlatList, StyleSheet, View } from 'react-native';
import HairLineDivider from 'shared/components/vxl/divider/HairlineDivider/HairLineDivider';
import ListItem from 'shared/components/vxl/ListItem/ListItem';
import LoadingSpinner from 'shared/components/vxl/loading/LoadingSpinner/LoadingSpinner';
import ExpoNavigationBar from 'shared/components/vxl/navigation/ExpoNavigationBar/ExpoNavigationBar';
import ErrorScreen from 'shared/patterns/vxl/errors/ErrorScreen/ErrorScreen';
import ScreenTransitionOverlay from 'shared/patterns/vxl/ScreenTransitionOverlay/ScreenTransitionOverlay';
import theme from 'shared/styles/theme';

const ClosedAccountsScreen = () => {
  const router = useRouter();
  const { setYearSelectionScreenTitle } = useContext(MyVaroContext);

  const { t: translatedText } = useTranslation('myVaro', {
    keyPrefix: 'statementsAndForms',
  });

  const { closedStatementsDetails, errorModel, loading } = useAccountStatements(
    {
      accountId: '',
      requestPolicy: 'cache-and-network',
    },
  );

  return (
    <View style={styles.container}>
      <Stack.Screen
        options={{
          headerShown: true,
          headerBackVisible: true,
          title: translatedText('closedAccounts.title'),
          header: (props: NativeStackHeaderProps) => (
            <ExpoNavigationBar {...props} />
          ),
        }}
      />
      <FlatList
        data={closedStatementsDetails}
        renderItem={({ item }) => (
          <ListItem
            key={item?.id}
            primaryCopy={`${item?.name} - ${item?.accountNumber}`}
            onPress={() => {
              setYearSelectionScreenTitle?.(item?.name);
              router.push({
                pathname:
                  '/reactivation/statements-and-forms/account-statements/[id]',
                params: {
                  id: item?.id,
                },
              });
            }}
          />
        )}
        ItemSeparatorComponent={() => (
          <View style={styles.hairLineDivider}>
            <HairLineDivider />
          </View>
        )}
        keyExtractor={(item) => item?.id}
        removeClippedSubviews={false}
      />

      <ScreenTransitionOverlay
        isLoading={loading}
        LoadingComponent={<LoadingSpinner />}
        ErrorComponent={errorModel ? <ErrorScreen {...errorModel} /> : null}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: theme.color.background.primary,
    flexGrow: 1,
  },
  hairLineDivider: { marginHorizontal: theme.spacing.m },
});

export default ClosedAccountsScreen;
